
import {FormGroup, FormControl} from '@angular/forms';

export function emailValidator(control : FormControl): {
[key: string]: boolean
} {
    var emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
    if (control.value && ! emailRegexp.test(control.value)) {
        return {invalidEmail: true};
    }
    return {};
}

export function cnpjValidator(control: FormControl): { [key: string]: boolean } {
  const cnpj = control.value;

  if (cnpj) {
    // Remova caracteres não numéricos
    const cleanedCnpj = cnpj.replace(/[^\d]/g, '');

    // Verifique se o CNPJ possui 14 dígitos
    if (cleanedCnpj.length !== 14) {
      return { invalidCnpj: true };
    }

    // Verificação dos dígitos verificadores
    const cnpjArray = cleanedCnpj.split('').map(Number);
    const calcDigits = (n: number) => {
      const slice = cnpjArray.slice(0, n);
      let factor = n - 7;
      let total = 0;
      for (let i = 0; i < n; i++) {
        total += slice[i] * factor;
        factor--;
        if (factor < 2) factor = 9;
      }
      const remainder = total % 11;
      const result = remainder < 2 ? 0 : 11 - remainder;
      return result;
    };

    const firstDigit = calcDigits(12);
    const secondDigit = calcDigits(13);

    if (cnpjArray[12] !== firstDigit || cnpjArray[13] !== secondDigit) {
      return { invalidCnpj: true };
    }
  }

  return {};
}

export function phoneValidator(control : FormControl): {
[key: string]: boolean
} {
    var telefoneRegexp = /^\d{10,11}$/;

    if (control.value && ! telefoneRegexp.test(control.value)) {
        return {invalidTelefone: true};
    }
    return {};
}

export function validaCEP(control : FormControl): {
[key: string]: boolean
} {
    var cepRegexp = /^\d{8}$/;

    if (control.value && ! cepRegexp.test(control.value)) {
        return {invalidCep: true};
    }
    return {};
}
